import React from "react";
import { ResponsiveLine } from "@nivo/line";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import { mockLineData } from "../data/mockData";

const LineChart = ({ dataUsed, isDashboard }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  // Calculate the minimum and maximum y-values from your data
  const minYValue = Math.min(
    ...dataUsed.map((dataItem) => Math.min(...dataItem.data.map((d) => d.y)))
  );
  const maxYValue = Math.max(
    ...dataUsed.map((dataItem) => Math.max(...dataItem.data.map((d) => d.y)))
  );

  // Custom tick formatter for dates
  const formatTick = (tick) => {
    const date = new Date(tick);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
    });
  };

  // Determine tick values based on the data length
  const calculateTickValues = (data) => {
    const dataLength = data.length;
    if (dataLength > 14) {
      return data.filter((_, index) => index % 7 === 0).map((item) => item.x); // every 7 days
    } else if (dataLength > 14) {
      return data.filter((_, index) => index % 3 === 0).map((item) => item.x); // every 3 days
    } else {
      return data.map((item) => item.x); // every day
    }
  };

  const tickValues = calculateTickValues(dataUsed[0].data);

  return (
    <ResponsiveLine
      theme={{
        axis: {
          domain: {
            line: {
              stroke: colors.grey[100],
            },
          },
          legend: {
            text: {
              fill: colors.grey[100],
              fontSize: 18,
            },
          },
          ticks: {
            line: {
              stroke: colors.grey[100],
              strokeWidth: 1,
            },
            text: {
              fill: colors.grey[100],
              fontSize: 15,
            },
          },
        },
        legends: {
          text: {
            fill: colors.grey[100],
            fontSize: 18,
          },
        },
        tooltip: {
          container: {
            background: colors.primary[400],
            color: colors.grey[100],
          },
        },
        labels: {
          text: {
            fontSize: 18,
          },
        },
      }}
      curve="linear"
      data={dataUsed}
      colors={isDashboard ? { datum: "color" } : { scheme: "nivo" }}
      // colors={{ scheme: "dark2" }}
      margin={{ top: 50, right: 200, bottom: 50, left: 60 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: false,
        reverse: false,
      }}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        format: formatTick,
        tickValues: tickValues,
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        // legend: "Kg/Cm",
        legendOffset: -40,
        legendPosition: "middle",
      }}
      enableGridX={true}
      enableGridY={true}
      pointSize={10}
      pointColor={{ from: "color", modifiers: [] }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor", modifiers: [] }}
      pointLabelYOffset={-12}
      enablePointLabel={true}
      useMesh={true}
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 100,
          translateY: 0,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
    />
  );
};

export default LineChart;
